module.exports = __webpack_public_path__ + "img/products.e02ed2c4.png";